(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function setEqualHeight() {
    if (window.innerWidth <= 750) {
      window.requestAnimationFrame(() => {
        document.querySelectorAll('[class*="footer-block--desktop-"]').forEach(block => {
          block.style.height = 'auto';
        });
      });
      return;
    }

    const blocks = [...document.querySelectorAll('[class*="footer-block--desktop-"]')];
    if (blocks.length === 0) return;

    let rows = [];
    let currentRow = [];
    let rowWidth = 0;

    window.requestAnimationFrame(() => {
      blocks.forEach(block => {
        block.style.height = 'auto';
      });
    });

    blocks.forEach(block => {
      const match = block.className.match(/footer-block--desktop-(\d+)/);
      const colSize = match ? parseInt(match[1]) : 0;

      if (rowWidth + colSize > 12) {
        rows.push(currentRow);
        currentRow = [];
        rowWidth = 0;
      }

      currentRow.push(block);
      rowWidth += colSize;
    });

    if (currentRow.length) rows.push(currentRow);

    rows.forEach(row => {
      const maxHeight = Math.max(...row.map(block => block.offsetHeight));
      window.requestAnimationFrame(() => {
        row.forEach(block => {
          block.style.height = `${maxHeight}px`;
        });
      });
    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    setTimeout(setEqualHeight, 100);
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setEqualHeight, 100);
  });

  if (Shopify.designMode) {
    const sectionId = "{{ section.id }}";

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.detail.sectionId === sectionId) {
        setTimeout(setEqualHeight, 100);
      }
    });
  
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === sectionId) {
        setTimeout(setEqualHeight, 100);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-pdrn-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hh-pdrn-product')) {
    customElements.define('hh-pdrn-product', class extends HTMLElement {
      connectedCallback() {
        if (this.hhPdrnController) return;
        this.hhPdrnController = new AbortController();
        const signal = this.hhPdrnController.signal;
        this.hhSlides = Array.from(this.querySelectorAll('[data-media-id]'));
        this.hhThumbs = Array.from(this.querySelectorAll('[data-gallery-target]'));
        this.hhSlideIndex = Math.max(0, this.hhSlides.findIndex(slide => !slide.hidden));
        this.hhVariants = [];
        const variantData = this.querySelector('[data-variant-data]');
        if (variantData) {
          try { this.hhVariants = JSON.parse(variantData.textContent); } catch (error) { this.hhVariants = []; }
        }
        this.addEventListener('click', event => {
          const step = event.target.closest('[data-gallery-step]');
          const target = event.target.closest('[data-gallery-target]');
          if (step && this.contains(step)) this.hhShowSlide(this.hhSlideIndex + Number(step.dataset.galleryStep));
          if (target && this.contains(target)) this.hhShowMedia(target.dataset.galleryTarget);
        }, { signal });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-native-variant]')) {
            const idInput = this.querySelector('.product-variant-id');
            if (idInput) {
              idInput.value = event.target.value;
              idInput.dataset.selectedId = event.target.value;
              idInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (event.target.matches('.product-variant-id') && !event.target.value.includes(',')) {
            this.hhUpdateVariant(event.target.value);
          }
        }, { signal });
        const gallery = this.querySelector('.hh-pdrn-p__gallery');
        if (gallery) {
          gallery.addEventListener('keydown', event => {
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
              event.preventDefault();
              this.hhShowSlide(this.hhSlideIndex + (event.key === 'ArrowRight' ? 1 : -1));
            }
          }, { signal });
          let touchX = null;
          gallery.addEventListener('touchstart', event => { touchX = event.touches[0].clientX; }, { signal, passive: true });
          gallery.addEventListener('touchend', event => {
            if (touchX === null) return;
            const distance = event.changedTouches[0].clientX - touchX;
            if (Math.abs(distance) > 55) this.hhShowSlide(this.hhSlideIndex + (distance < 0 ? 1 : -1));
            touchX = null;
          }, { signal, passive: true });
        }
      }
      disconnectedCallback() {
        if (this.hhPdrnController) this.hhPdrnController.abort();
        this.hhPdrnController = null;
      }
      hhShowSlide(index) {
        if (!this.hhSlides.length) return;
        const next = (index + this.hhSlides.length) % this.hhSlides.length;
        this.hhSlides.forEach((slide, current) => {
          slide.hidden = current !== next;
          if (current !== next) {
            slide.querySelectorAll('video').forEach(video => video.pause());
            slide.querySelectorAll('iframe').forEach(frame => {
              try {
                const origin = new URL(frame.src, window.location.href).origin;
                frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), origin);
                frame.contentWindow.postMessage({ method: 'pause' }, origin);
              } catch (error) { }
            });
          }
        });
        this.hhSlideIndex = next;
        const id = this.hhSlides[next].dataset.mediaId;
        this.hhThumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === id)));
        const thumb = this.hhThumbs.find(button => button.dataset.galleryTarget === id);
        if (thumb) {
          const container = thumb.parentElement;
          if (thumb.offsetLeft < container.scrollLeft || thumb.offsetLeft + thumb.offsetWidth > container.scrollLeft + container.clientWidth) container.scrollLeft = thumb.offsetLeft - container.clientWidth / 2 + thumb.offsetWidth / 2;
        }
      }
      hhShowMedia(id) {
        const index = this.hhSlides.findIndex(slide => slide.dataset.mediaId === String(id));
        if (index !== -1) this.hhShowSlide(index);
      }
      hhUpdatePrice(variant) {
        if (!variant) return;
        const price = this.querySelector('[data-main-price]');
        const compare = this.querySelector('[data-main-compare]');
        const compareWrap = this.querySelector('[data-compare-wrap]');
        const savingWrap = this.querySelector('[data-saving-wrap]');
        const savingLabel = this.querySelector('[data-saving-label]');
        if (price) price.textContent = variant.price;
        if (compare) compare.textContent = variant.compare;
        if (compareWrap) compareWrap.hidden = !variant.compare;
        if (savingWrap) savingWrap.hidden = !variant.compare;
        if (savingLabel) savingLabel.textContent = savingLabel.dataset.savingTemplate.replace('[percent]', String(variant.savingPercent)).replace('[amount]', variant.savingAmount);
      }
      hhUpdateVariant(id) {
        const variant = this.hhVariants.find(item => item.id === String(id));
        const button = this.querySelector('.hh-pdrn-p__submit');
        const label = this.querySelector('[data-submit-label]');
        if (button) button.disabled = !variant || !variant.available;
        if (label) label.textContent = !variant ? this.dataset.unavailableLabel : variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        if (!variant) return;
        this.hhUpdatePrice(variant);
        const quantity = this.querySelector('.product_quantity_input');
        if (quantity) {
          quantity.min = variant.minimum;
          quantity.step = variant.increment;
          if (variant.maximum !== null) quantity.max = variant.maximum;
          else quantity.removeAttribute('max');
          let value = Math.max(variant.minimum, Number(quantity.value) || variant.minimum);
          value = variant.minimum + Math.floor((value - variant.minimum) / variant.increment) * variant.increment;
          if (variant.maximum !== null) value = Math.min(value, variant.maximum);
          quantity.value = value;
        }
        if (variant.mediaId && this.dataset.previewMode !== 'true') this.hhShowMedia(variant.mediaId);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url);
        this.dispatchEvent(new CustomEvent('hh-pdrn:variant-change', { bubbles: true, detail: { variant } }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
